<script>
    export let store;

    function goToPurchase() {
        store.setState("BUNDLE_PURCHASE");
    }
</script>

<div class="flex flex-row my-2 text-md text-center space-x-1">
    <p>No Voucher?</p>
    <button
        class="text-blue-500 hover:text-blue-700"
        on:click={goToPurchase}
    >
        Buy Voucher Now
    </button>
</div>
